import { render } from "./ManagePlaylists.vue?vue&type=template&id=64620be4"
import script from "./ManagePlaylists.vue?vue&type=script&setup=true&lang=js"
export * from "./ManagePlaylists.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Playlists/ManagePlaylists.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "64620be4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('64620be4', __exports__)) {
    api.reload('64620be4', __exports__)
  }
  
  module.hot.accept("./ManagePlaylists.vue?vue&type=template&id=64620be4", () => {
    api.rerender('64620be4', render)
  })

}


export default __exports__